<style lang="scss" scoped>
.sortable-row-demo .drag-btn {
  cursor: move;
  font-size: 12px;
}
.sortable-row-demo .vxe-body--row.sortable-ghost,
.sortable-row-demo .vxe-body--row.sortable-chosen {
  background-color: #dfecfb;
}
</style>
<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      row-key
      size="small"
      resizable
      border
      ref="XGrid"
      class="sortable-row-demo"
      :scroll-y="{ enabled: false }"
    >
      <template v-slot:opt="{ row }">
        <div>
          <b-button-group>
            <b-button
              v-b-tooltip.hover
              class="mr-2"
              size="sm"
              variant="outline-secondary"
              @click="
                openEditFormDialog({
                  type: 'detail',
                  contactCode: row.contactCode,
                })
              "
            >
              <b-icon-eye></b-icon-eye>
            </b-button>
            <b-button
              v-b-tooltip.hover
              class="mr-2"
              size="sm"
              variant="outline-secondary"
              @click="
                openEditFormDialog({
                  type: 'edit',
                  contactCode: row.contactCode,
                })
              "
            >
              <b-icon-pencil></b-icon-pencil>
            </b-button>
            <b-button
              v-b-tooltip.hover
              class="mr-2"
              variant="outline-secondary"
              size="sm"
              @click="del(row.contactCode)"
            >
              <b-icon-trash-fill></b-icon-trash-fill>
            </b-button>
          </b-button-group>
        </div>
      </template>
      <template v-slot:incomeCostAmount="{ row }">
        <div>
          <el-link type="primary" @click="showFeeDetail(row)">{{
            row.incomeCostAmount
          }}</el-link>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>

    <el-dialog
      v-if="editFormDialogOptions.visible"
      v-el-dialog-drag
      show-close
      visible
      width="700px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :contactCode="editFormDialogOptions.contactCode"
        :custStatementCode="code"
        @reload="getData"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
          v-if="!editFormDialogOptions.disabled"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Sortable from 'sortablejs'
import editForm from './edit-form'
import tableColumns from './customerbill-table-columns'
export default {
  components: { editForm },
  props: {
    code: {
      type: String,
    },
  },
  data() {
    return {
      showHelpTip1: false,
      tableColumns: tableColumns(),
      tableData: [],
      editFormDialogOptions: {
        visible: false,
        contactCode: '',
        custStatementCode: '',
      },
    }
  },
  created() {
    this.rowDrop()
  },
  mounted() {
    this.getData()
  },
  beforeDestroy() {
    if (this.sortable1) {
      this.sortable1.destroy()
    }
  },
  methods: {
    rowDrop() {
      this.$nextTick(() => {
        const xTable = this.$refs.XGrid
        this.sortable1 = Sortable.create(
          xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'),
          {
            handle: '.drag-btn',
            onEnd: ({ newIndex, oldIndex }) => {
              const currRow = this.tableData.splice(oldIndex, 1)[0]
              this.tableData.splice(newIndex, 0, currRow)
              this.updateNo(newIndex + 1, oldIndex + 1)
            },
          }
        )
      })
    },
    updateNo(newIndex, oldIndex) {
      if (newIndex === oldIndex) return
      this.$api
        .masterCustomerContactUpdateNoApi({
          newIndex: newIndex,
          oldIndex: oldIndex,
          custStatementCode: this.code,
        })
        .then(() => {
          this.getData()
        })
    },
    getData() {
      if (!this.code) return
      this.$api
        .finCustomerStatementDetaiListApi({
          custStatementCode: this.code,
        })
        .then((res) => {
          this.tableData = res.body.data

          this.rowDrop()
        })
    },
    showFeeDetail(row) {
      let data = row.incomeCostDetail
      let detail = []
      let msg = ''
      if (data === '[]' || !data) {
        msg = '无费用明细'
      } else {
        detail = JSON.parse(data)
        detail.forEach((item) => {
          msg +=
            '<strong>' +
            item.feeNameText +
            '：<i>' +
            item.basePrice +
            '</i></strong><br/>'
        })
      }
      this.$alert(msg, '费用明细', {
        type: 'default',
        dangerouslyUseHTMLString: true,
      })
    },
  },
}
</script>
